var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimism(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122 122",
    style: {
      enableBackground: "new 0 0 122 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0420;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "optimism-logo",
    transform: "translate(-219 -213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }), /*#__PURE__*/React.createElement("g", {
    id: "optimism-logo-circle",
    transform: "translate(219 213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    className: "st0",
    cx: 61,
    cy: 61,
    r: 61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    className: "st1",
    d: "M43.2,77.2c-3.2,0.1-6.3-0.8-8.9-2.6c-2.3-1.8-3.6-4.5-3.4-7.4c0-0.8,0.1-1.7,0.2-2.5 c0.4-2.2,1-4.8,1.7-7.9c2.1-8.4,7.4-12.6,16.1-12.6c2.2,0,4.3,0.4,6.3,1.2c1.8,0.7,3.3,1.9,4.4,3.5c1.1,1.6,1.7,3.5,1.6,5.5 c0,0.8-0.1,1.6-0.2,2.4c-0.5,2.7-1,5.4-1.6,7.9c-1.1,4.2-2.9,7.3-5.5,9.4C51.1,76.2,47.6,77.2,43.2,77.2z M43.8,70.6 c1.6,0,3.1-0.5,4.3-1.5c1.3-1.2,2.3-2.8,2.6-4.6c0.7-2.9,1.2-5.4,1.6-7.5c0.1-0.6,0.2-1.3,0.2-2c0-2.8-1.4-4.2-4.3-4.2 c-1.6,0-3.2,0.5-4.4,1.5c-1.3,1.2-2.2,2.8-2.6,4.6c-0.5,2-1.1,4.5-1.6,7.5c-0.1,0.6-0.2,1.3-0.2,1.9 C39.4,69.2,40.9,70.6,43.8,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    className: "st1",
    d: "M63.2,76.7c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.2-0.5-0.1-0.8l6.3-29.7c0.1-0.3,0.2-0.6,0.5-0.8 c0.2-0.2,0.6-0.3,0.9-0.3h12.2c2.9-0.1,5.7,0.6,8.1,2.1c2,1.3,3.2,3.7,3.1,6.1c0,0.8-0.1,1.6-0.3,2.4c-0.5,3.1-2.2,5.9-4.6,7.8 c-2.3,1.7-5.4,2.5-9.4,2.5h-6.2l-2.1,10c-0.1,0.3-0.2,0.6-0.5,0.8c-0.2,0.2-0.6,0.3-0.9,0.3L63.2,76.7z M79.4,59.2 c1.2,0,2.4-0.3,3.3-1.1c1-0.7,1.7-1.8,1.9-3c0.1-0.5,0.1-0.9,0.1-1.4c0.1-0.8-0.2-1.5-0.8-2c-0.8-0.6-1.7-0.8-2.7-0.7h-5.5 l-1.7,8.2L79.4,59.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.9528f5acdb201629107599cd64dd6c23.svg";
export { ForwardRef as ReactComponent };